export default class ComponentsConnector {
    callback
    callbackReceiver = (callback)=>{this.callback = callback;}
    call=()=>{if(this.callback) this.callback();}
}